import { AppContextState, INITIAL_STATE, AppDevice } from "./AppContext.ts";
import { Breakpoint } from "@mui/material";
import { AuthTempInfo, AuthUser } from "@/types/Auth.ts";
import { Company } from "@/types/Company.ts";
import { CompletedSupport } from "@/types/Support";
import { Channel } from "@/types/Channel.ts";
import { AppModules } from "@/types/Module.ts";

type AppContextActions =
  | { type: "setAuthUser"; payload: AuthUser }
  | { type: "setAuthTempInfo"; payload: AuthTempInfo }
  | { type: "setLoaded"; payload: boolean }
  | { type: "setMenuOpen"; payload: boolean }
  | { type: "setBreakPoint"; payload: Breakpoint }
  | { type: "setDevice"; payload: AppDevice }
  | { type: "setCompany"; payload: Company }
  | { type: "setChannels"; payload: Channel[] }
  | { type: "setCompletedSupport"; payload: CompletedSupport[] }
  | { type: "cleanState" };

export const AppReducer = (state: AppContextState, action: AppContextActions): AppContextState => {
  switch (action.type) {
    case "setAuthUser":
      return {
        ...state,
        auth: { ...state.auth, user: action.payload },
      };

    case "cleanState": {
      localStorage.clear();

      return {
        ...(INITIAL_STATE as AppContextState),
      };
    }

    case "setLoaded": {
      return {
        ...state,
        loaded: action.payload,
      };
    }

    case "setAuthTempInfo": {
      return {
        ...state,
        auth: { ...state.auth, tempInfo: action.payload },
      };
    }

    case "setMenuOpen":
      return {
        ...state,
        menu: { ...state.menu, open: action.payload },
      };

    case "setBreakPoint":
      return {
        ...state,
        layout: { ...state.layout, breakpoint: action.payload },
      };

    case "setDevice":
      return {
        ...state,
        layout: { ...state.layout, device: action.payload },
      };

    case "setCompany":
      return {
        ...state,
        menu: { ...state.menu, items: state.menu.items.map(item => {
          if (item.id === AppModules.SUPPORTS)
            return { ...item, disabled: !action.payload.enable_material_support };
          return item;
        }) },
        company: action.payload,
      };

    case "setChannels":
      return {
        ...state,
        channels: action.payload,
      };


    case "setCompletedSupport":
      return {
        ...state,
        support: { ...state.support, completed: action.payload },
      };

    default:
      return state;
  }
};
